module.exports = __webpack_public_path__ + "img/icon_default_person.7ded1f65.svg";